import { ComponentChildren } from 'preact'
import { TargetedEvent, useEffect, useRef } from 'preact/compat'

import { useFootnotes } from './FootnoteProvider'

interface FootnoteProps {
  children: ComponentChildren
  id: string | number
}

export function FootnoteLink({ children, id }: FootnoteProps) {
  const [, getFootnote] = useFootnotes()
  const timeoutRef = useRef<NodeJS.Timeout>()

  useEffect(
    () => () => {
      clearTimeout(timeoutRef.current)
    },
    [],
  )

  const handleClickFootnote = (e: TargetedEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    const footnote = getFootnote(id.toString())
    if (footnote) {
      footnote.scrollIntoView({ behavior: 'smooth', block: 'center' })

      footnote.classList.remove('no-highlight')
      footnote.classList.add('highlight')

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

      timeoutRef.current = setTimeout(() => {
        footnote.classList.remove('highlight')
        footnote.classList.add('no-highlight')
      }, 1000)
    }
  }

  return (
    <a
      href={`#footnote-${id}`}
      className="cursor-pointer inline-block aspect-square rounded-full no-underline appearance-none text-current focus:outline-none focus:ring focus:ring-sunshine/80 hover:text-current before:absolute before:content-[''] before:w-4 before:h-4 before:rounded-full before:-translate-y-1/8 before:-translate-x-1/4"
      onClick={handleClickFootnote}>
      {children}
    </a>
  )
}
